<template>
    <!-- Layout inner -->
    <div class="layout-inner pg_entity_list enrolled_course">
      <!-- Layout navbar -->
      <navbar></navbar>
      <!-- / Layout navbar -->
      <div class="layout-container">
        <div class="layout-content">

          <div class="hd_bar">
            <div class="hd_ic">
              <span class="ic-course"></span>
            </div>
            <div class="hd_txt_sm" style="float: left; margin-top: 14px;">
              <span class="title_txt">Enrolled Courses</span>
            </div>
            <div class="btn_container">
              <b-button class="btn" aria-label="previous" :disabled="disableLeftButton" @click="clickLeft()">
                <span class="ic ic-arr_next2"></span>
              </b-button>
              <b-button class="btn" aria-label="next" :disabled="disableRightButton" @click="clickRight()">
                <span class="ic ic-arr_next"></span>
              </b-button>
            </div>
          </div>

          <!-- Page content -->
          <div class="container-fluid flex-grow-1 pg_content_container">
            <template v-if="showPage">
              <template v-if="courses.length === 0">
                <p class="text-center">No enrolled courses.</p>
              </template>
              <div class="row">
                <template v-for="course in courses">
                  <div class="col-sm-3 col-xl-3">
                    <div class="card entity_block">
                      <div class="card-body" @click="navigateToCourse(course.uuid)">
                        <div class="thumbnail course">
                          <span class="txt_bx" v-html="setTitleInitials(course.title)"></span>
                        </div>
                          <div class="title_container">
                            <div class="entity_title">{{course.title}}</div>
                            <div class="entity_detail">{{course.lmsCourseId}}</div>
                          </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </template>
            <template v-else>
              <div class="w-100 h-100 d-flex justify-content-center align-items-center">
                <spinner size="large"></spinner>
              </div>
            </template>
          </div>
          <!-- / Page content -->

          <!-- Footer Navbar -->
          <footer-navbar></footer-navbar>
          <!-- / Footer Navbar -->
        </div>
      </div>
    </div>
    <!-- Layout inner -->
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Navbar from '../../misc/components/./Navbar'
import SecondaryNavbar from '../../misc/components/./SecondaryNavbar'
import FooterNavbar from '../../misc/components/./FooterNavbar'

export default {
  name: 'courses',
  props: [],
  components: {
    Navbar,
    SecondaryNavbar,
    FooterNavbar
  },
  data: () => {
    return {
      courses: [],
      page: 0,
      count: 5,
      maxCourses: 99999,
      showPage: false
    }
  },

  mounted () {
    this.loadCourses()
  },

  methods: {
    ...mapActions([
      'loadEnrolledCourses',
      'loadUserObj'
    ]),
    async loadCourses () {
      let pagingOptions = {page: this.page, count: this.count}
      this.courses = await this.loadEnrolledCourses(pagingOptions)
      await this.loadUserObj()
      this.showPage = true
    },
    navigateToCourse (courseId) {
      this.$router.push({name: 'courseDashboard', params: { uuid: courseId }})
    },
    async clickLeft () {
      if (this.page > 0) {
        this.page = this.page - 1
        this.courses = await this.loadEnrolledCourses({page: this.page, count: this.count})
      }
    },
    async clickRight () {
      if (this.page <= this.maxCourses) {
        this.page = this.page + 1
        this.courses = await this.loadEnrolledCourses({page: this.page, count: this.count})
        if (this.courses.length < 1) {
          this.maxCourses = this.page - 1
          this.page = this.maxCourses
          this.courses = await this.loadEnrolledCourses({page: this.page, count: this.count})
        }
      }
    },
    setTitleInitials (entityTitle) {
      let getTitleInitials = entityTitle.match(/\b(\w)/g)
      return getTitleInitials.join('')
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj
    }),
    disableLeftButton () {
      if (this.page < 1) {
        return true
      }
      return false
    },
    disableRightButton () {
      if (this.page >= this.maxCourses) {
        return true
      }
      return false
    },
    userName () {
      if (this.userObj) {
        return this.userObj.firstName + ' ' + this.userObj.lastName
      } else {
        return ''
      }
    },
    major () {
      if (this.userObj) {
        return this.userObj.major1Title
      } else {
        return ''
      }
    },
    majorGPA () {
      if (this.userObj) {
        return this.userObj.majorGpa
      } else {
        return '0.0'
      }
    },
    overallGPA () {
      if (this.userObj) {
        return this.userObj.overallGpa
      } else {
        return '0.0'
      }
    }
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/Courses.vue